
import { useState, useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { Organization } from "@/types/organizationTypes";

export const useOrganizationCoreSettings = (organizationId?: string) => {
  const [organization, setOrganization] = useState<Organization | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchOrganizationData = async () => {
    // Check if organizationId is undefined, null, or empty string
    if (!organizationId) {
      console.log("No organization ID provided to useOrganizationCoreSettings");
      setLoading(false);
      setError(new Error("No organization ID provided"));
      return;
    }

    console.log("Fetching organization data for ID:", organizationId);
    setLoading(true);
    try {
      const { data, error: fetchError } = await supabase
        .from("organizations")
        .select("*")
        .eq("id", organizationId)
        .single();

      if (fetchError) {
        console.error("Error fetching organization:", fetchError.message);
        setError(new Error(fetchError.message));
        setOrganization(null);
      } else if (data) {
        console.log("Organization data loaded successfully:", data.name);
        setOrganization(data as Organization);
        setError(null);
      } else {
        console.warn("No organization found with ID:", organizationId);
        setError(new Error("Organization not found"));
        setOrganization(null);
      }
    } catch (err) {
      console.error("Unexpected error in fetchOrganizationData:", err);
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizationData();
  }, [organizationId]);

  return {
    organization,
    loading,
    error,
    setOrganization,
    refreshOrganizationData: fetchOrganizationData,
  };
};
